export default {
  dashboards: state => {
    const dashboards = [];

    Object
      .entries(state.universes)
      .forEach(([universeId, dashboardsOfUniverse]) => {
        // eslint-disable-next-line complexity
        dashboardsOfUniverse.forEach(dashboard => {
          dashboards.push({
            universeId,
            accountId: dashboard.accountId,
            isStaging: dashboard.isStaging,
            dashboardId: dashboard.id,
            title: dashboard.data.title,
            userEmails: dashboard.data.userEmails,
            users: dashboard.data.users,
            expiresTrialDate: dashboard.data.expiresTrialDate,
            onboardingStatus: dashboard.data.onboardingStatus,
            createdByAccessPage: dashboard.data.createdByAccessPage,
            audit: {
              createdBy: dashboard.data.audit ? dashboard.data.audit.createdBy : '',
              createdByEmail: dashboard.data.audit ? dashboard.data.audit.createdByEmail : '',
              createdDate: dashboard.data.audit ? dashboard.data.audit.createdDate : '',
              updatedBy: dashboard.data.audit ? dashboard.data.audit.updatedBy : '',
              updatedByEmail: dashboard.data.audit ? dashboard.data.audit.updatedByEmail : '',
              updatedDate: dashboard.data.audit ? dashboard.data.audit.updatedDate : '',
            },
          });
        });
      });

    return dashboards;
  },
};
